import filesize from "filesize";
import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { isAudioFile, isPostFileData } from "@/lib/fileHelpers";
import { getMediaDuration } from "@/lib/time";
import { PostFileData } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import { LoadingListItem } from "@/components/ContentLoadingPlaceholders";

interface Props {
  postFile: PostFileData | ContentFile;
}

export default Vue.extend({
  functional: true,
  props: {
    postFile: { required: true },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { postFile } = ctx.props;
    const uploadingProgress = isPostFileData(postFile) ? postFile.uploadProgress : 100;
    const icon = isAudioFile(postFile) ? "sci-music-box" : "sci-file";
    const description =
      isAudioFile(postFile) && postFile.duration ? getMediaDuration(postFile.duration) : filesize(postFile.size);
    const name = isPostFileData(postFile) ? postFile.fileName : postFile.title;

    const scopedSlots = {
      default: ({ loaded, loading }: { loaded: boolean; loading: boolean }) => [
        ctx.scopedSlots.prepend && ctx.scopedSlots.prepend({ file: postFile }),
        <div staticClass={"post-file-item__prepend"}>
          <BaseIcon fontSize={"24"}>{icon}</BaseIcon>
        </div>,
        <div staticClass={"post-file-item__content mx-1"}>
          <div staticClass={"post-file-item__name"} class={{ __awaitUpload: !loaded && !loading }}>
            {(ctx.scopedSlots.header && ctx.scopedSlots.header({ fileName: name, file: postFile })) || name}
          </div>
          <div class="post-file-item__description">{description}</div>
        </div>,
        ctx.scopedSlots.append && ctx.scopedSlots.append({ file: postFile }),
      ],
    };
    return (
      <LoadingListItem
        class={ctx.data.class}
        staticClass={ctx.data.staticClass + " post-file-item d-flex py-3"}
        progress={uploadingProgress}
        scopedSlots={scopedSlots}
      />
    );
  },
});
